import { render } from "./SyncDialog.vue?vue&type=template&id=3794a49a&ts=true"
import script from "./SyncDialog.vue?vue&type=script&lang=ts"
export * from "./SyncDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__